import { action } from 'mobx';
import { stores } from 'contexts';

export const GRAPHQL_SUPPORT_ERROR_MESSAGE =
  'Something went wrong. Contact support.';

/**
 * Enqueue the shared GraphQL failure snackbar once (avoids stacking duplicates
 * when several queries fail in the same tick).
 */
export const showGraphqlSupportSnackbar = action(function showGraphqlSupportSnackbar() {
  const { snackbarMessages } = stores.appStore;
  if (snackbarMessages.includes(GRAPHQL_SUPPORT_ERROR_MESSAGE)) {
    return;
  }
  stores.appStore.snackbarMessages = [
    ...snackbarMessages,
    GRAPHQL_SUPPORT_ERROR_MESSAGE,
  ];
});
